import { configs } from '$configs';
import { fetchApi } from '$gbusiness/services/api';
import { randomInt } from '$gbusiness/helpers/util';

export const sendEmailByChunk = async (list, request) => {
  const { from, email, subject, body, files } = request;

  const response = await fetchApi({
    url: configs.api.factory.email,
    param: {
      stores: list,
      fromEmail: email,
      fromName: from,
      subject,
      body,
      files,
    },
  });

  if (!response || response?.numSuccess === undefined) {
    return [list.length, 0];
  }

  return [response.numFailure, response.numSuccess];
};

export const splitList = (list, min = 0, max = 5) => {
  if (list.count < 5) return list;
  const tempList: Array<number> = [...list];
  const newArray = [] as any;

  while (tempList.length > 0) {
    newArray.push(tempList.splice(0, randomInt(min, max)));
  }

  return newArray;
};
